'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = FormLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./form-label.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH FormLabel Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function FormLabel(props) {
    var _cx;

    var _props$htmlFor = props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? '' : _props$htmlFor,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-form-label': true
    }, (0, _defineProperty3.default)(_cx, 'sb-form-label--' + style, style), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('label', {
        htmlFor: htmlFor,
        className: classNames,
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=FormLabel.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/formLabel/FormLabel.js
// module id = 557
// module chunks = 0